import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=62a45ca2&scoped=true&"
var script = {}
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=62a45ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a45ca2",
  null
  
)

export default component.exports